import Vue from 'vue';
import {
  getSerials, sendPoint
} from '../../../services/backendService/linePointService';

// initial state
// state 必為模組區域變數，取時需 store.state.auth.user
// 其他則視 default 內是否有設 namespaced = true 來決定是全域還是區域
// 區域使用時值需加上 name
const state = {
  serials: [],
};

 // actions
const actions = {
  // 取得序號活動
  async getSerialHandler({ commit }) {
    const data = await getSerials();
    commit('setSerials', data);
  },
  // 發送LINE Point訊息
  async pushPointHandler({}, data) {
    await sendPoint(data);
  },
};

// mutations
const mutations = {
  setSerials(state, data) {
    Vue.set(state, 'serials', data.data.data);
  },
};

export default {
  namespaced: true,
  state,
  actions,
  mutations
};
